import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHThirtyNinePreLogin',
    name: 'IFPageOneHThirtyNinePreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHThirtyNine/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHThirtyNineLogin' ||
        from.path === '/IFPageOneHThirtyNineLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHThirtyNineLogin',
    name: 'pageOneHThirtyNineLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHThirtyNine/login.vue'),
  },
  {
    path: '/IFPageOneHThirtyNineLoginLoading',
    name: 'pageOneHThirtyNineLoginLoading',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHThirtyNine/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHThirtyNineLeaveInfo',
    name: 'pageOneHThirtyNineLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHThirtyNine/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHThirtyNineResult',
    name: 'pageOneHThirtyNineResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHThirtyNine/result.vue'),
  },
  {
    path: '/IFPageOneHThirtyNineLoading',
    name: 'pageOneHThirtyNineLoading',
    component: () => import('@/pages/pageListAll/pageOneHThirtyNine/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHThirtyNineLoginSecond',
    name: 'pageOneHThirtyNineLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHThirtyNine/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHThirtyNineOnline',
    name: 'pageOneHThirtyNineOnline',
    component: () => import('@/pages/pageListAll/pageOneHThirtyNine/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHThirtyNineLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHThirtyNineGuide',
    name: 'pageOneHThirtyNineLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHThirtyNine/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  {
    path: '/IFPageOneHThirtyNineCar',
    name: 'pageOneHThirtyNineCar',
    component: () => import('@/pages/pageListAll/pageOneHThirtyNine/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHThirtyNineCarDetails',
    name: 'pageOneHThirtyNineCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHThirtyNine/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },
  {
    path: '/IFPageOneHThirtyNineBlank',
    name: 'pageOneHThirtyNineBlank',
    component: () => import('@/pages/pageListAll/pageOneHThirtyNine/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHThirtyNineOnlineTab',
    name: 'pageOneHThirtyNineOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHThirtyNine/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHThirtyNineOnlineAd',
    name: 'pageOneHThirtyNineOnlineAd',
    component: () => import('@/pages/pageListAll/pageOneHThirtyNine/onlineAd.vue'),
    meta: {
      title: projectName,
    },
  },
];
